var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v("Sub Setting 3")]),_c('v-card-text',[_c('p',[_vm._v("This is the demo page for Sub Setting 3.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }